var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NxSelect',{attrs:{"value":_vm.localValue,"options":_vm.listOptions,"labelText":"Origens:","id":"selectOrigem","placeholder":"Selecione a(s) Origem(s)","multiple":true},on:{"update:value":_vm.handleValueUpdate}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd78fae2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nexum/components/custom-selects/NxSelectOrigem.vue
// module id = null
// module chunks = 